<div class="wrapper">
  <div class="header">
    <div class="title">Why just help one person?</div>
    <div class="subtext">Save more lives in one go.</div>
  </div>
  <div class="card">
    <div class="cardtile" *ngFor="let item of infolist">
      <div class="top">
        <img [attr.data-src]="item?.story_widget?.cdn_path" alt="">
        <div class="timeleft">
          <i class="material-icons">schedule</i>
          <span>{{(item?.end_date | dayjs:'diffInDays') + ' Days ' }}left</span>
        </div>
      </div>
      <div class="bottom">
        <div class="content">
          <div class="causetitle">Support {{item?.beneficiaryname.info_1.split(" ")[0]}}</div>
          <div class="causename">{{item?.title}}</div>
          <div class="moneyshort"  *ngIf="amtRemainig(item?.raised?.raised,item?.amount_requested)"><strong><app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon> {{amtRemainig(item?.raised?.raised,item?.amount_requested) | inrFormat}} needed</strong></div>
        </div>
        <div class="dntbtn">
          <button *ngIf="!selected.includes(item.id)" class="btn" (click)="val = hide(item.id)">
            Add Donation
          </button>
        </div>
        <div class="incrementbtn" *ngIf="selected.includes(item.id)">
          <button class="plus" (click)="amtchanger('minus', item.id)" mat-ripple>
            <i class="material-icons">remove</i>
          </button>
          <div><app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon>{{amt[item.id].amount}}</div>
          <button class="minus" (click)="amtchanger('plus', item.id)" [ngClass]="{'max': amt[item.id].amount === minamount[currency].minamt * 10}" mat-ripple>
            <i class="material-icons">add</i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="submitbtn">
    <button (click)="submit()" mat-button [disabled]="config?.isOrderLoading ? true : false">
      <span *ngIf="!config?.isOrderLoading">{{btnlabel}}</span>
      <div *ngIf="config?.isOrderLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
    </button>
  </div>
</div>